// import React from 'react';
// import { Modal, Button } from 'react-bootstrap';
// import activateDeactivateLogo from '../Assets/images/deactivate.png'
// const DeleteConfirmationModal = ({ show, onHide, onConfirm, title = "Confirm Delete", body = "Are you sure you want to delete this item?" ,type ="delete"}) => {
//   return (
//     <Modal className="el-deactivate-modal" show={show} centered onHide={onHide}>
//       <Modal.Header  closeButton>
//         <Modal.Title>{title}</Modal.Title>
//         <img src={activateDeactivateLogo} className="img-fluid deactivateimg" alt="" />
//       </Modal.Header>
//       <Modal.Body>
//       <h2> {body}</h2>
//       </Modal.Body>
//       <Modal.Footer>
//       <Button variant="danger" onClick={onConfirm}>
//          {type == 'deactivateactivate' ? 'Yes': 'Delete'}
//         </Button>
//         <Button variant="secondary" onClick={onHide}>
//           Cancel
//         </Button>

//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default DeleteConfirmationModal;


import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import activateDeactivateLogo from '../Assets/images/deactivate.png';
import deleteGif from '../Assets/images/delete.gif';
import { FaFlask } from "react-icons/fa";
const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title = "Confirm Delete",
  body = "Are you sure you want to delete this item?",
  type = "delete"
}) => {
  return (
    <Modal show={show} centered onHide={onHide} dialogClassName="el-deactivate-modal" >
      {/* backdrop="static" */}
      <Modal.Body className="text-center">

        {type === 'deactivateactivate' ? (<img src={activateDeactivateLogo} className="img-fluid deactivateimg mb-3" alt="Deactivate" />) :  type === 'save-sr' ? ( <div className='mb-2'><FaFlask style={{height:'100%', width:'10%'}}></FaFlask></div>) :  type ===  'donor-no-show' ? (<></>) : (<img src={deleteGif} className="img-fluid deactivateimg mb-3" alt="Deactivate" />)}

        <h2>{body}</h2>
        <div className="d-flex my-3 w-f-content justify-content-center mx-auto">
          <button variant="outline-primary" className="el-main-button" onClick={onConfirm}>
            <span> {type === 'deactivateactivate' ? 'Yes' :  type === 'remove-st' ? 'Remove' :  type === 'save-sr'? 'Submit' :  type ===  'donor-no-show' ? 'Confirm': 'Delete'}   </span> 
          </button>
          <button variant="outline-primary" className="back-link close-btn ms-3" onClick={onHide}>
              {type ==='remove-st' ? 'Close' :   type === 'save-sr'? 'Go Back' : type ===  'donor-no-show' ? 'Close': 'No'}
          </button>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
